import { render } from "./Menu.vue?vue&type=template&id=704c221d&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=704c221d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-704c221d"

export default script